var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 79,
    rx: 7.5,
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 24L56 32M57.3333 28L60 30.6667M60 25.3333L62.6667 28M54.6667 40C54.6667 38.2319 53.9643 36.5362 52.714 35.286C51.4638 34.0357 49.7681 33.3333 48 33.3333M54.6667 40C52.8986 40 51.2029 39.2976 49.9526 38.0474C48.7024 36.7971 48 35.1014 48 33.3333M54.6667 40C64.24 40 72 32.24 72 22.6667M48 33.3333C48 23.76 55.76 16 65.3333 16M65.3333 16C67.1014 16 68.7971 16.7024 70.0474 17.9526C71.2976 19.2029 72 20.8986 72 22.6667M65.3333 16C65.3333 17.7681 66.0357 19.4638 67.286 20.714C68.5362 21.9643 70.2319 22.6667 72 22.6667",
    stroke: "#1BC4CF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7566 52.8182V63H54.1159L49.3184 56.0646H49.2338V63H47.3894V52.8182H49.0399L53.8326 59.7585H53.922V52.8182H55.7566ZM57.6263 63V52.8182H64.1491V54.3643H59.4708V57.1286H63.7016V58.6747H59.4708V63H57.6263ZM65.6895 63V52.8182H67.5339V61.4538H72.0183V63H65.6895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame 1.cbbc3d2ea203270da97414ab17484db3.svg";
export { ForwardRef as ReactComponent };